import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface GetByIdRepairsQueryOptions {
  id: Ref<string>;
}

export const getByIdRepairsQuery = (options: GetByIdRepairsQueryOptions) => {
  return queryOptions({
    queryKey: ["repairs", "get-by-id", options.id],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["getByIdRepairs"][200]
    > =>
      handleClientMethod(
        getClient().GET("/repairs/{id}", {
          params: {
            path: {
              id: options.id.value,
            },
          },
        }),
      ),
  });
};
